(function($){

  $('.oclock-sticky__products-dropdown').on('change', function(){
    var oclockProduct = $(this).val();

    $('.oclock-sticky__add-to-cart').removeClass('enabled');

    $('.oclock-sticky__add-to-cart[data-product-form="'+oclockProduct+'"]').addClass('enabled');
  });

  $('.oclock-ingredients__item-ingredient h4').on('click', function(){
    $('.oclock-ingredients__item-ingredient').removeClass('expanded');
    $(this).parent().addClass('expanded');
  });
  
  // Blends Section Slider
  $('.oclock-blends-times').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.oclock-blends',
    focusOnSelect: true
  });

  $('.oclock-blends').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.oclock-blends-times'
  });

  // Featured Products Section Slider
  $('.oclock-featured-products').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });

  // Reviews Section Slider
  $('.oclock-reviews').slick({
    centerMode: true,
    centerPadding: '23%',
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: '0',
          dots: true,
          arrows: false
        }
      }
    ]
  });

  // Ingredients Section Sliders
  $('.oclock-times').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.oclock-ingredients',
    focusOnSelect: true
  });

  $('.oclock-ingredients').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.oclock-times'
  });

})(jQuery);